/**
 * GAVION skip-callback: a callback is « Demandé » when the person asked for it (the last result is « Parlé – rappeler »,
 * talked_callback), « Auto » otherwise (the automatic follow-up after a voicemail, a brochure or no answer).
 */
export type CallbackKind = "requested" | "auto";

export const callbackKind = (
  lastCallOutcome: string | null | undefined,
): CallbackKind =>
  lastCallOutcome === "talked_callback" ? "requested" : "auto";
